import { Link } from "react-router-dom"

function Nav() {
    return (
        <nav class="navbar navbar-wrapper navbar-default navbar-fade is-fixed-top is-transparent">
            <div class="container">
                <div class="navbar-brand">
                    <Link class="navbar-item" to="/">
                        <img class="switcher-logo" src="./../../assets/img/logos/logo.png" width={"250%"} height={"250%"} alt="" />
                    </Link>
                </div>
            </div>
        </nav>
    )
}

export default Nav